import React, { useContext, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import VerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied'
import SatisfiedIcon from '@material-ui/icons/SentimentSatisfiedAlt'
import NeutralIcon from '@material-ui/icons/SentimentSatisfied'
import DissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied'
import VeryDissatisfiedIcon from '@material-ui/icons/MoodBad'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import { SessionContext } from './session-context'
import { finishConversationRating } from './js/data-providers'

const useStyles = makeStyles(theme => ({
  ratingDivOuter: {
    margin: '10px auto 10px auto',
    display: 'flex',
    justifyContent: 'center'
  },
  ratingDivInner: {
    display: 'flex',
    width: 250,
    justifyContent: 'space-between'
  },
  emojiIcon: {
    fontSize: '40px',
    cursor: 'pointer',
    marginRight: 5,
    '&:hover': {
      fontSize: '45px',
      marginRight: 0
    }
  },
  starIcon: {
    fontSize: '40px',
    cursor: 'pointer',
    fill: 'gold'
  }
}))

const Ratings = [
  { icon: VeryDissatisfiedIcon, color: '#F0706F', value: 1 },
  { icon: DissatisfiedIcon, color: '#eba21a', value: 2 },
  { icon: NeutralIcon, color: '#e8e825', value: 3 },
  { icon: SatisfiedIcon, color: '#59e3da', value: 4 },
  { icon: VerySatisfiedIcon, color: '#1bd40b', value: 5 }
]

function RatingComplete (props) {
  const classes = useStyles()
  const rating = props.rating
  const ratingType = props.ratingType

  if (ratingType === 'emojis') {
    const r = Ratings.filter(r => r.value === rating)[0]

    return (
      <div style={{ marginRight: 25, display: 'flex', justifyContent: 'flex-end' }}>
        <r.icon style={{ fill: r.color, fontSize: '50px' }} />
      </div>
    )
  } else if (ratingType === 'five_stars') {
    return (
      <div className={classes.ratingDivOuter}>
        <div className={classes.ratingDivInner}>
          {[1, 2, 3, 4, 5].map(r => {
            if (r <= rating) {
              return (
                <StarIcon className={classes.starIcon} key={r} />
              )
            } else {
              return (
                <StarBorderIcon className={classes.starIcon} key={r} />
              )
            }
          })}
        </div>
      </div>
    )
  }
}

function RatingDrop (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const classes = useStyles()
  const [hover, setHover] = useState(0)
  const rating_event_id = props.event_id
  const ratingType = props.ratingType
  const completedRatings = props.completedRatings

  const completeEvent = completedRatings[rating_event_id]

  if (completeEvent) {
    const rating = completeEvent.attributes.data.rating
    return (
      <RatingComplete
        rating={rating}
        ratingType={ratingType}
      />
    )
  }

  if (ratingType === 'emojis') {
    return (
      <div className={classes.ratingDivOuter}>
        <div className={classes.ratingDivInner}>
          {Ratings.map(rating => (
            <rating.icon
              className={classes.emojiIcon}
              style={{ fill: rating.color }}
              key={rating.value}
              onClick={() => finishConversationRating({ rating_event_id, rating: rating.value, ratingType, token, chatServiceUrl })}
            />
          ))}
        </div>
      </div>
    )
  } else {
    return (
      <div className={classes.ratingDivOuter}>
        <div className={classes.ratingDivInner} onMouseLeave={() => setHover(0)}>
          {[1, 2, 3, 4, 5].map(rating => {
            if (rating <= hover) {
              return (
                <StarIcon
                  className={classes.starIcon}
                  key={rating}
                  onMouseEnter={() => setHover(rating)}
                  onClick={() => finishConversationRating({ rating_event_id, rating, ratingType, token, chatServiceUrl })}
                />
              )
            } else {
              return (
                <StarBorderIcon
                  className={classes.starIcon}
                  key={rating}
                  onMouseEnter={() => setHover(rating)}
                  onClick={() => finishConversationRating({ rating_event_id, rating, ratingType, token, chatServiceUrl })}
                />
              )
            }
          })}
        </div>
      </div>
    )
  }
}

export default RatingDrop
